import { render, staticRenderFns } from "./GiftmainFilter.vue?vue&type=template&id=25bb8b43&"
import script from "./GiftmainFilter.vue?vue&type=script&lang=js&"
export * from "./GiftmainFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports